import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Radio, Paper, Tooltip, ListItem } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import StackedBarChart from "../StackedBarChart";
import GroupedBarLineChart from "../GroupedBarLineChart";
import GroupedBarMultipleLineChart from "../GroupedBarMultipleLineChart";
import { useSelector } from "react-redux";
import DoBarChart from "../DoBarChart";
import { COFMockData, RedeployCost } from "../../../../data/mockdata";
import DPBarChart from "../DPBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import { InputLabel } from "@material-ui/core";
import ChartsForRR from "./BarChartsForRR";
import { active } from "d3";
import BarChartsForRR from "./BarChartsForRR";
import BarLineChartForRR from "./BarLineChartForRR";
import { setModuleTabIndex } from "../../../../store/Actions";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
  dropDownLabel: {
    marginTop: "2px",
  },
}));

const GraphViewRR = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  rapidResponseDates,
  applyFilter,
  role,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  // const [chartData, setChartData] = useState([]);
  // const chartData = [];
  const [unitValue, setUniteValue] = useState("Dollars");
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  // const categoryList = "";
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue
  )[0].name;
  const activeFlagValue = useSelector((state) => state?.filter?.activeFlag);
  const [byWeeksOrMonths, setByWeeksOrMonths] = useState("Weekly");
  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [countValue, setCountValue] = useState("5");
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const selectedScenarios = useSelector(
    (state) => state?.filter?.selectedScenarios
  );
  const recomFlag = useSelector((state) => state?.filter?.recomFlag);
  const radioOptions = () => {
    const optionsMap = {
      Timeline: ["Event", "Source DC", "Destination DC"],
      "Order Recom": ["Event", "Source DC", "Destination DC"],
      "Fine Reductions": ["Event", "Source DC", "Destination DC"],
      "STO Recommendations": [
        "Destination DC",
        "Source DC",
        "Material ID",
        "Division",
      ],
      "Salvage Moves": [
        "Source DC",
        "Destination DC",
        "Material ID",
        "Division",
      ],
    };

    return optionsMap[activeTab] || [];
  };
  const [selectedRadioValue, setSelectedRadioValue] = useState(
    radioOptions()[0]
  );

  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphData(data?.data);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };

  const memoizedParams = useMemo(
    () => ({
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name: unitValue,
      X_Axis: selectedRadioValue,
      KPI: byWeeksOrMonths,
      value: countValue,
      acceptCondition: recomFlag,
      scenarioCondition: selectedScenarios?.map((item) => item?.value),
      units: unitValue,
      arrangements: topOrBottomValue,
      Level: role,
      filter: {
        RecommendedDC: DC,
        Network: Network,
        PL3: PL3,
        Division: Division,
        Products: Products,
        startDate: rapidResponseDates?.[0],
        endDate: rapidResponseDates?.[1],
      },
    }),
    [
      Module,
      tabValue,
      role,
      DC,
      Network,
      PL3,
      Division,
      Products,
      rapidResponseDates,
      activeFlagValue,
      unitValue,
      selectedRadioValue,
      topOrBottomValue,
      byWeeksOrMonths,
      countValue,
      selectedScenarios,
      recomFlag,
    ]
  );

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);

  const handleChange = (_event, newValue) => {
    setGraphData([]);
    moduleTabIndexChange(newValue);
    setSelectedRadioValue(
      newValue === 3 || newValue === 4 ? "Destination DC" : "Event"
    );
    setTopOrBottomValue("Top");
    setCountValue("5");
  };

  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };

  const handleByWeeksOrMonth = (event) => {
    setByWeeksOrMonths(event.target.value);
  };

  const handleTopBottomChange = (event) => {
    setTopOrBottomValue(event.target.value);
  };

  const handleCountChange = (event) => {
    setCountValue(event.target.value);
  };

  const handleUniteChange = (event) => {
    setUniteValue(event.target.value);
  };

  const renderChart = () => {
    // if(graphData?.length > 0){
    if (activeTab === "Timeline") {
      return (
        <BarLineChartForRR
          graphData={graphData}
          activeTab={activeTab}
          type={selectedRadioValue}
        />
      );
    } else {
      return (
        <BarChartsForRR
          graphData={graphData}
          activeTab={activeTab}
          type={activeTab === "Order Recom" ? unitValue : ""}
        />
      );
    }
    //}
  };

  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
                    </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack direction="row" spacing={1} alignItems="center">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {activeTab === "Timeline" && (
                      <Select
                        value={byWeeksOrMonths}
                        onChange={handleByWeeksOrMonth}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={classes.select}
                      >
                        <MenuItem value={"Weekly"}>By Weeks</MenuItem>
                        <MenuItem value={"Monthly"}>By Months</MenuItem>
                      </Select>
                    )}
                    {(activeTab === "Order Recom" ||
                      activeTab === "Fine Reductions" ||
                      activeTab === "STO Recommendations" ||
                      activeTab === "Salvage Moves") && (
                      <>
                        <Select
                          value={topOrBottomValue}
                          onChange={handleTopBottomChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          sx={classes.select}
                        >
                          <MenuItem value="Top">Top</MenuItem>
                          <MenuItem value={"Bottom"}>Bottom</MenuItem>
                        </Select>

                        <Select
                          value={countValue}
                          onChange={handleCountChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          sx={classes.select}
                        >
                          {countList.map((item, _index) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    )}

                    {radioOptions().map((option) => (
                      <React.Fragment key={option}>
                        <Radio
                          value={option}
                          checked={selectedRadioValue === option}
                          onChange={() => handleRadioChange(option)}
                          size="small"
                          inputProps={{ "aria-label": option }}
                          sx={{
                            color: "#359DD0 !important",
                            "&.Mui-checked": {
                              color: "#359DD0 !important",
                            },
                          }}
                        />
                        <span
                          className={classes.filter}
                          style={{
                            color:
                              selectedRadioValue ===
                              (Module === "SNO" ? "Overall" : "Network")
                                ? "#359DD0"
                                : "#359DD0",
                          }}
                        >
                          {option}
                        </span>
                      </React.Fragment>
                    ))}
                  </div>
                  {activeTab === "Order Recom" && (
                    <div style={{ marginRight: "-10px" }}>
                      <Select
                        value={unitValue}
                        onChange={handleUniteChange}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={classes.select}
                      >
                        <MenuItem value={"Dollars"}>Dollars</MenuItem>
                        <MenuItem value={"Orders"}>Orders</MenuItem>
                      </Select>
                    </div>
                  )}
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

GraphViewRR.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
  rapidResponseDates: state.filter.rapidResponseDates,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphViewRR);
